import React from 'react';
import PropTypes from 'prop-types';
import { Autocomplete, FormControl, FormHelperText, TextField } from '@mui/material';
import { Row, Col } from "react-bootstrap";
import { useController, useForm, useFormContext } from 'react-hook-form';

export default function AutocompleteInput(props) {

  const { name, selectOptions, id, variant, onChange, value, onInputChange, disabled, filterOptions, isFetching } = props;
  const formContext = useFormContext();
  const fallbackForm = useForm();
  const { control } = formContext ?? fallbackForm;
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control
  });

  const handleChange = (newValue) => {
    if (newValue === null) {
      field.onChange("")
      onChange("");
    } else {
      field.onChange(newValue.value)
      onChange && onChange(newValue.value)
    }
  }

  return (
    <Row>
      <Col xs={12}>
        <FormControl
          fullWidth
          variant={variant || "filled"}
          error={!!error}
        >
          <Autocomplete
            id={id}
            value={value}
            options={selectOptions}
            onChange={(event, newValue) => handleChange(newValue)}
            onInputChange={onInputChange}
            loading={isFetching}
            disabled={disabled}
            filterOptions={filterOptions}
            getOptionLabel={(option) => option.label}
            inputProps={props.inputProps}
            renderInput={(params) => <TextField {...params} label={props.label} variant={variant || "filled"} slotProps={{
              ...params.slotProps,
              htmlInput: { ...params.slotProps.htmlInput, maxLength: 25 }
            }} />}
          />
          <FormHelperText>{error && error.message}</FormHelperText>
        </FormControl>
      </Col>
    </Row>
  );
}

AutocompleteInput.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  selectOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.any.isRequired,
    label: PropTypes.any.isRequired,
    disabled: PropTypes.bool,
  })).isRequired,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
  variant: PropTypes.string,
}